export const MAX_REFERENCE_FILE_SIZE = 50 * 1024 * 1024

export const starterPrompts = [
  {
    key: 'suggest',
    icon: 'star',
    title: 'Suggest for me',
    description: 'AI reads the story and suggests a vision.',
    actionLabel: 'Start',
    recommended: true,
    message:
      'Read my story and suggest a clear visual direction before we generate the shot list.'
  },
  {
    key: 'questions',
    icon: 'question-circle',
    title: 'Ask me questions',
    description: 'AI asks guided questions to shape the look.',
    actionLabel: 'Start',
    action: 'start'
  },
  {
    key: 'known-style',
    icon: 'edit',
    title: 'I know the style',
    description: 'Tell the AI your style and references.',
    actionLabel: 'Start',
    message:
      'I already have a visual style in mind. Ask me only the key questions needed before the shot list.'
  }
]

export const PHASE_VIEWS = {
  vision: {
    label: 'Vision',
    navLabel: 'Vision',
    shortLabel: 'Vision',
    icon: 'file-text',
    title: 'Vision',
    description: 'Chat with the AI and save the visual vision.',
    primaryNoun: 'vision',
    tip: 'Save the vision when it is clear enough to guide the next steps.'
  },
  characters: {
    label: 'Characters',
    navLabel: 'Characters',
    shortLabel: 'Characters',
    icon: 'team',
    title: 'Characters',
    description: 'Extract, review, and generate the characters in the story.',
    primaryNoun: 'characters',
    generatedLabel: 'character assets',
    tip: 'Characters may require approval before the next phase opens.'
  },
  outfits: {
    label: 'Outfits',
    navLabel: 'Outfits',
    shortLabel: 'Outfits',
    icon: 'skin',
    title: 'Outfits',
    description: 'Create outfit sheets and visual continuity for the characters.',
    primaryNoun: 'outfits',
    generatedLabel: 'wardrobe sheets',
    tip: 'Generate wardrobe sheets before moving into world building.'
  },
  locations: {
    label: 'Locations',
    navLabel: 'Locations',
    shortLabel: 'Locations',
    icon: 'global',
    title: 'Locations',
    description: 'Build the location boards for the film.',
    primaryNoun: 'locations',
    generatedLabel: 'location boards',
    tip: 'Location counts can include base locations and variants.'
  },
  storyboard: {
    label: 'Storyboard',
    navLabel: 'Storyboard',
    shortLabel: 'Storyboard',
    icon: 'layout',
    title: 'Storyboard',
    description: 'Discuss, lock, and generate storyboard sheets through chat.',
    primaryNoun: 'panels',
    generatedLabel: 'storyboard sheets',
    tip: 'Ask the AI to write the plan, revise it, lock it, and generate boards.'
  },
  finalized: {
    label: 'Creative Guideline',
    navLabel: 'Creative Guideline',
    shortLabel: 'Guideline',
    icon: 'book',
    title: 'Creative Guideline',
    description: 'Finalize the creative guideline and unlock the shot list.',
    primaryNoun: 'guideline',
    generatedLabel: 'creative guideline',
    tip: 'The next step unlocks after the creative guideline is finalized.'
  }
}
